import React, {useState, useEffect} from "react";
import {useHistory} from 'react-router-dom';
import {Box} from '@mui/material';
import {useTranslation} from 'react-i18next';
import ButtonComponent from '../components/ButtonComponent';
import {BUTTON_PRIMARY, BUTTON_WARNING, SUCCESS, ERROR, TOAST_ERROR} from '../assets/constants/Constants';
import {BOOKING_SUMMARY, CANCEL_OR_ERROR_PAGE, LOCKER_SIZE_SELECTION, LOCKER_UNIT_SELECTION, OPEN_LOCKER, PARCEL_OWNER, PAYMENT_GATEWAY, SUCCESS_PAGE} from '../assets/constants/PageList';
import {LOCAL_STORAGE, SESSION_STORAGE, LS_LOCKER_BANK_INFO, LS_TENANT_ASSIGNMENT_LOCKER_BANK_SETTINGS, SS_PAYMENT_GATEWAY, SS_PAYMENT_GATEWAY_ACCESS_KEY, LS_IS_REDIRECTED_FROM_STRIPE_PAYMENT_GATEWAY, LS_PROP_LOCKER_UNIT_DETAILS} from '../assets/constants/BrowserStorageKeys';
import {getSecureItemFromSpecificStorage, storeSecureItemInSpecifiedStorage} from '../lib/BrowserStorageAccessMiddleware';
import { reserveLocker} from '../api/api';
import {prePaymentRegistration} from '../lib/BackendUtils';
import {getPathForNextPage, convertDurationStringToMilliseconds, verifyUserProximity, toFeetInches, getPriceFor24Hr, getSlotIdFor24Hourse, findMatchingSlotByDuration, getRoundedDurationInHours, getPriceForSelectedTiming, getRoundedDurationInDays, normalizeTermsList, getUnitLabelParams} from '../lib/Utils';
import CustomDialog from '../components/CustomDialog';
import ShowToast from '../components/ToastComponent';
import DuroltLogoIcon from "../assets/images/durolt_logo_new.svg";
import LockerIcon from '../assets/locker.svg';
import MSizeImage from '../assets/images/M_SIZE.jpg';
import LSizeImage from '../assets/images/L_SIZE.jpg';
import ExtraLSizeImage from '../assets/images/EXTRA_L_SIZE.jpg';
import LockerModalContent from "../components/LockerBookingSlotComponent";
import getSymbolFromCurrency from 'currency-symbol-map';

const LockerSizePage = () => {
    const history = useHistory();
    const {t} = useTranslation();
    const lockerBankInfo = getSecureItemFromSpecificStorage(LOCAL_STORAGE, LS_LOCKER_BANK_INFO);
    const tenantAndAssignmentSettings = getSecureItemFromSpecificStorage(LOCAL_STORAGE, LS_TENANT_ASSIGNMENT_LOCKER_BANK_SETTINGS);
    const unitLabelParams = getUnitLabelParams(lockerBankInfo?.LockerBankType, t);
    const [isLoading, setIsLoading] = useState(true);
    const [loadingMessage, setLoadingMessage] = useState(t('Loading'));
    const state = history.location?.state || {};
    const {
    lockerBankId,
    assignmentSlug,
    userId,
    availableLockerSizes = [],
    IsAdvanceBooking = false,
    address = "",
    bookingTimingObject = [],
    locker_bank_slug,
    isManualLockerSelectionEnabled,
    lockerCurrency = 'null',
    selectedLockers: preselectedLockers = []
    } = state;
    const isPricingEnabled = tenantAndAssignmentSettings?.is_pricing;
    const isParcelDropUser = tenantAndAssignmentSettings?.usecase_settings?.show_drop_btn_pwa?.value;
    const [selectedSizeId, setSelectedSizeId] = useState(null);
    const [selectedSlotId, setSelectedSlotId] = useState(null);
    const [userProximityError, setUserProximityError] = useState('');
    const [isUserProximityErrorModalVisible, setIsUserProximityErrorModalVisible] = useState(false);
    const [showBookingInstructionModal, setShowBookingInstructionModal] = useState(false);
    const [selectedLockers, setSelectedLockers] = useState(preselectedLockers || []);
    const [showBulkSlotModal, setShowBulkSlotModal] = useState(false);
    const [bulkSelectedDuration, setBulkSelectedDuration] = useState(null);
    const [pendingInstructionLockers, setPendingInstructionLockers] = useState(null);
        
    useEffect(() => {
        if (isPricingEnabled && !IsAdvanceBooking ) {
            sortAndFormatSlotDuration();
        }
        setIsLoading(false);
    }, []);

    const increaseQty = (locker, price24h) => {
    if (Number(locker?.available_doors_count) <= 0) return;
    if (!IsAdvanceBooking && locker?.bookingSlots && locker?.size_pricing) {
         setSelectedLockers((prev) => {
        const count = prev.filter(
        (item) => item.door_size === locker.code
        ).length;

        if (count >= locker.available_doors_count) return prev;

        return [
        ...prev,
        {
            door_size: locker.code,
            name: t('locker_size_code_locker', { code: locker.name, ...unitLabelParams }),
            bookingSlots:locker?.bookingSlots,
            currency:locker?.currency
        },
        ];
    });
        
    }else{
    setSelectedLockers((prev) => {
        const count = prev.filter(
        (item) => item.door_size === locker.code
        ).length;

        if (count >= locker.available_doors_count) return prev;

        const roundedDays = getRoundedDurationInDays(
            bookingTimingObject?.reserve_start,
            bookingTimingObject?.reserve_end
        );

        return [
        ...prev,
        {
            door_size: locker.code,
            price: IsAdvanceBooking ? 
            getPriceForSelectedTiming(getRoundedDurationInHours(bookingTimingObject?.reserve_start , bookingTimingObject?.reserve_end ),price24h) : 0,
            durations: [
            {
                label: `${roundedDays} ${roundedDays === 1 ? 'day' : 'days'}`,
                price: IsAdvanceBooking ? getPriceForSelectedTiming(getRoundedDurationInHours(bookingTimingObject?.reserve_start , bookingTimingObject?.reserve_end ),price24h) : 0,
            },
            ],
            name: t('locker_size_code_locker', { code: locker.name, ...unitLabelParams }),
            slot_id: getSlotIdFor24Hourse(locker?.size_pricing)
        },
        ];
    });
    };}

    const decreaseQty = (locker) => {
    if (Number(locker?.available_doors_count) <= 0) return;

    setSelectedLockers((prev) => {
        const index = prev.findIndex(
        (item) => item.door_size === locker.code
        );

        if (index === -1) return prev;

        const newArray = [...prev];
        newArray.splice(index, 1);

        return newArray;
    });
    };


const totalPrice = selectedLockers.reduce((sum, locker) => {
    return sum + locker.price;
}, 0);

    const sortAndFormatSlotDuration = () => {
        availableLockerSizes.forEach((lockerSize) => {
            lockerSize.dimensions = `${parseFloat(lockerSize.width)}\" x ${parseFloat(lockerSize.length)}\" x ${parseFloat(lockerSize.height)}\"`;

            lockerSize.size_pricing.forEach((slot) => {
                slot.durationInMilliseconds = convertDurationStringToMilliseconds(slot.duration);
            });

            const incrementallySortedBookingSlots = sortBookingSlotsBasedOnDuration(lockerSize.size_pricing);

            let previousDurationInMilliseconds = 0;
            incrementallySortedBookingSlots.forEach((slot) => {
                slot.durationRange = `${previousDurationInMilliseconds / 3600000} - ${slot.durationInMilliseconds / 3600000} Hours`;
                previousDurationInMilliseconds = slot.durationInMilliseconds;
            });

            lockerSize.bookingSlots = incrementallySortedBookingSlots;
        });
    };
    // avaid this below funtion for advance booking
    const sortBookingSlotsBasedOnDuration = (slotsArray) => {
        return slotsArray.slice().sort((a, b) => a.durationInMilliseconds - b.durationInMilliseconds);
    };

    const lockerSizeClickHandler = (item) => {
        if (isParcelDropUser) {
            history.replace({
                pathname:getPathForNextPage(LOCKER_SIZE_SELECTION, PARCEL_OWNER),
                state: {
                    lockerSize: item.code,
                    lockerItem:item,
                }
            })            
        }
        else {
            lockerSizeSelectionHandler(item);
        }
    }

    
     
    const lockerSizeSelectionHandler = async (item) => {
        if (isManualLockerSelectionEnabled) {
            history.replace({
                pathname: getPathForNextPage(LOCKER_SIZE_SELECTION, LOCKER_UNIT_SELECTION),
                state: {
                    lockerBankId,
                    assignmentSlug,
                    userId,
                    selectedLockerSize: item
                }
            });
        }
        else {
            setIsLoading(true);
            try {
                if (tenantAndAssignmentSettings?.is_geofencing) {
                    const lockerBankLatitude = lockerBankInfo?.latitude ? parseFloat(lockerBankInfo?.latitude) : null;
                    const lockerBankLongitude = lockerBankInfo?.longitude ? parseFloat(lockerBankInfo?.longitude) : null;
                    const maxAllowedDistanceInMeters = tenantAndAssignmentSettings?.geofencing_radius;
                    const isUserNearbyLockerBank = await verifyUserProximity({latitude: lockerBankLatitude, longitude: lockerBankLongitude}, maxAllowedDistanceInMeters);
                    
                    if ( !isUserNearbyLockerBank.isNearby ) {
                        setLoadingMessage('');
                        setIsLoading(false);
                        setUserProximityError(isUserNearbyLockerBank.message);
                        setIsUserProximityErrorModalVisible(true);
        
                        return;
                    }
                }

                const reserveLockerResponse = await reserveLocker(assignmentSlug, lockerBankId, userId, item.code);
                if (reserveLockerResponse.status === SUCCESS) {
                    const lockerUnitDetails = {
                        ref_id: reserveLockerResponse?.data?.transaction_id,
                        is_already_opened_once: false,
                        locker_bank: {
                            name: reserveLockerResponse?.data?.locker_bank_name
                        },
                        locker_door: {
                            door_no: reserveLockerResponse?.data?.door_no
                        }
                    };

                    history.replace({
                        pathname: getPathForNextPage(LOCKER_SIZE_SELECTION, OPEN_LOCKER),
                        state: {
                            lockerUnitDetails
                        }
                    });
                }
            } catch (error) {
                setIsLoading(false);
                console.error('Error while reserving locker: ', error);
            }
        }
    };

    const bookButtonHandler = async () => {
        setLoadingMessage(t('initiating_transaction_please_wait'));
        setIsLoading(true);

        if (tenantAndAssignmentSettings?.is_geofencing) {
            const lockerBankLatitude = lockerBankInfo?.latitude ? parseFloat(lockerBankInfo?.latitude) : null;
            const lockerBankLongitude = lockerBankInfo?.longitude ? parseFloat(lockerBankInfo?.longitude) : null;
            const maxAllowedDistanceInMeters = tenantAndAssignmentSettings?.geofencing_radius;
            const isUserNearbyLockerBank = await verifyUserProximity({latitude: lockerBankLatitude, longitude: lockerBankLongitude}, maxAllowedDistanceInMeters);
            
            if ( !isUserNearbyLockerBank.isNearby ) {
                setLoadingMessage('');
                setIsLoading(false);
                setUserProximityError(isUserNearbyLockerBank.message);
                setIsUserProximityErrorModalVisible(true);

                return;
            }
        }

        const selectedSize = availableLockerSizes.filter((lockerSize) => selectedSizeId === lockerSize?.id)[0];
        const selectedSlot = selectedSize?.size_pricing.filter((slot) => selectedSlotId === slot?.id)[0];

        const reserveLockerResponse = await reserveLockerTillSuccessfulPayment(selectedSize, selectedSlot);
        
        if (reserveLockerResponse?.status === SUCCESS) {
            const prePaymentResponse = await makePrePaymentRegistration(reserveLockerResponse.data);

            if (prePaymentResponse?.status === SUCCESS) {

                const lockerUnitDetails = {
                    ref_id: reserveLockerResponse?.data?.transaction_id,
                    is_already_opened_once: false,
                    locker_bank: {
                        name: reserveLockerResponse?.data?.locker_bank_name
                    },
                    locker_door: {
                        door_no: reserveLockerResponse?.data?.door_no
                    }
                };

                if (prePaymentResponse?.data?.data?.payment_gateway === 'stripe') {
                    lockerUnitDetails.payment_records = [
                        {
                            payment_gateway: prePaymentResponse?.data?.data?.payment_gateway,
                            payment_gateway_reference: prePaymentResponse?.data?.data?.payment_id,
                            transaction_id: prePaymentResponse?.data?.data?.transaction_id
                        }
                    ];
                    storeSecureItemInSpecifiedStorage(LOCAL_STORAGE, LS_IS_REDIRECTED_FROM_STRIPE_PAYMENT_GATEWAY, true);
                    storeSecureItemInSpecifiedStorage(LOCAL_STORAGE, LS_PROP_LOCKER_UNIT_DETAILS, lockerUnitDetails);

                    window.location.href = prePaymentResponse?.data?.data?.field_1;
                    return;
                }

                const lockerData = {
                    reservedLocker: reserveLockerResponse?.data,
                    locker_bank: {
                        name: reserveLockerResponse?.data?.locker_bank_name,
                        location: {
                            name: reserveLockerResponse?.data?.locker_bank_location
                        }
                    },
                    assignment: {
                        payment_gateway: [ reserveLockerResponse?.data?.assignment_payment_gateway ]
                    },
                    payment_records: [
                        { amount: prePaymentResponse?.data?.data?.amount }
                    ],
                    user: {
                        username: reserveLockerResponse?.data?.username ? reserveLockerResponse?.data?.username : "",
                        email: reserveLockerResponse?.data?.transaction_payments[0]?.user_email ? reserveLockerResponse?.data?.transaction_payments[0].user_email : "",
                        mobile_number: reserveLockerResponse?.data?.transaction_payments[0]?.user_mobile ? reserveLockerResponse?.data?.transaction_payments[0].user_mobile : ""
                    }
                };
                storeSecureItemInSpecifiedStorage(SESSION_STORAGE, SS_PAYMENT_GATEWAY, prePaymentResponse?.data?.data?.payment_gateway);
                storeSecureItemInSpecifiedStorage(SESSION_STORAGE, SS_PAYMENT_GATEWAY_ACCESS_KEY, prePaymentResponse?.data?.data?.payment_gateway_reference);

                setIsLoading(false);

                history.replace({
                    pathname: getPathForNextPage(LOCKER_SIZE_SELECTION, PAYMENT_GATEWAY),
                    state: {
                        lockerUnitDetails,
                        isLockerReservedTillSuccessfulPayment: true,
                        lockerData,
                        currentReferenceId: prePaymentResponse?.data?.data?.transaction_id,
                    }
                });
            }
            else if (prePaymentResponse.status === ERROR) {
                ShowToast(t(prePaymentResponse.message), TOAST_ERROR);
            }
        }

        setIsLoading(false);
    };

    const reserveLockerTillSuccessfulPayment = async (selectedSize, selectedSlot) => {
        try {
            return await reserveLocker(assignmentSlug, lockerBankId, userId, selectedSize?.code, null, selectedSlot?.id, parseFloat(selectedSlot?.price));
        } catch (error) {
            console.error('Error while reserving locker before payment: ', error);
        }
    };

    const makePrePaymentRegistration = async (lockerData) => {
        try {
            const body = {
                "payment_reference_id": lockerData?.transaction_payments[0]?.transaction_id,
                "payment_gateway": lockerData?.transaction_payments[0]?.payment_gateway,
                "locker_bank_id": lockerBankId,
                "locker_door_number": lockerData?.door_no,
                "amount": lockerData?.transaction_payments[0]?.amount,
                "currency": lockerData?.transaction_payments[0]?.currency,
                "payment_mode": lockerData?.transaction_payments[0]?.payment_mode
            };

            if (lockerData?.transaction_payments[0]?.payment_gateway === 'stripe') {
                body.success_url = `${window.location.protocol}//${window.location.host}${getPathForNextPage(PAYMENT_GATEWAY, SUCCESS_PAGE)}`;
                body.cancel_url = `${window.location.protocol}//${window.location.host}${getPathForNextPage(PAYMENT_GATEWAY, CANCEL_OR_ERROR_PAGE)}`;
            }

            return await prePaymentRegistration(body);
        } catch (error) {
            console.error('Error while initating payment: ', error);
        }
    };


    const renderBookingInstructionsModalContent = () => {
        const lockerBankTerms = normalizeTermsList(lockerBankInfo?.terms);

        const defaultInstructions = [
            t('luggageLockerInstructionsPoint1', unitLabelParams),
            t('luggageLockerInstructionsPoint2', unitLabelParams),
            t('luggageLockerInstructionsPoint3', unitLabelParams),
            t('luggageLockerInstructionsPoint4', unitLabelParams),
            t('luggageLockerInstructionsPoint5', unitLabelParams),
            t('luggageLockerInstructionsPoint6', unitLabelParams),
            t('luggageLockerInstructionsPoint7', unitLabelParams)
        ];

       const instructions = lockerBankTerms.length > 0 ? lockerBankTerms : defaultInstructions;
        return (
            <div className="booking-instructions">
                <ol className="instructions-list list-decimal">
                    {instructions.map((instruction, index) => (
                        <li key={`${instruction}-${index}`}>{instruction}</li>
                    ))}
                </ol>
            </div>
        );
    }

    const goToBookingSummary = (lockersOverride = null) => {
        const lockersToSend = lockersOverride || selectedLockers;
        history.push({
            pathname: getPathForNextPage(LOCKER_SIZE_SELECTION, BOOKING_SUMMARY),
            state: {
                ...state,
                lockerBankId,
                assignmentSlug,
                address,
                bookingTimingObject,
                locker_bank_slug,
                isManualLockerSelectionEnabled,
                IsAdvanceBooking,
                lockerCurrency,
                selectedLockers: lockersToSend
            }
        });
    };

    const handleSelectedLokcerObject = ()=>{
            // check for advance-booking or normal bulk booking
            if(isPricingEnabled && IsAdvanceBooking){
                setPendingInstructionLockers(selectedLockers);
                setShowBookingInstructionModal(true);
            }else if(isPricingEnabled && !IsAdvanceBooking){
                // show slot selection modal for normal booking (bulk)
                if (selectedLockers?.length && selectedLockers[0]?.bookingSlots?.length) {
                    setShowBulkSlotModal(true);
                } else {
                    goToBookingSummary();
                }
            }
    }


    const handleBulkConfirmSlot = ({ durationInMilliseconds }) => {
        setBulkSelectedDuration(durationInMilliseconds);

        const updated = selectedLockers.map((locker) => {
            const matchedSlot = locker?.bookingSlots?.find(
                (s) => s.durationInMilliseconds === durationInMilliseconds
            );

            return {
                ...locker,
                selectedSlot: matchedSlot || null,
            };
        });

        setSelectedLockers(updated);
        setShowBulkSlotModal(false);
        setPendingInstructionLockers(updated);
        setShowBookingInstructionModal(true);
    };

    const handleBookingInstructionsContinue = () => {
        setShowBookingInstructionModal(false);
        goToBookingSummary(pendingInstructionLockers || selectedLockers);
        setPendingInstructionLockers(null);
    };

    const handleBookingInstructionsCancel = () => {
        setShowBookingInstructionModal(false);
        setPendingInstructionLockers(null);
    };

     const convertToInch = (w, d, h) => {
    if (!w || !d || !h) return "";
    return `${toFeetInches(w)} W x ${toFeetInches(d)} D x ${toFeetInches(h)} H`;
  };

    const getLockerSizeImage = (lockerCode) => {
        switch (lockerCode) {
            case "M":
                return MSizeImage;
            case "L":
                return LSizeImage;
            case "XL":
                return ExtraLSizeImage;
            default:
                return LockerIcon;
        }
    };

    return (
        <Box className='locker-size-page'>
            <div className="main-container-temp">
            <div className="main">
                {availableLockerSizes?.length > 0 ? (
                    <>
                    {availableLockerSizes.map((locker) => {
                        const availableDoorsCount = Number(locker?.available_doors_count || 0);
                        const isLockerUnavailable = availableDoorsCount <= 0;
                        const selectedLockerCount = selectedLockers.filter(
                            (item) => item.door_size === locker.code
                        ).length;
                        const price24h = IsAdvanceBooking ? getPriceFor24Hr(locker.size_pricing) : null;
                        return (
                            <div
                                key={locker.id}
                                className={`locker-card${isLockerUnavailable ? " disabled-locker-card" : ""}`}
                                style={{
                                    opacity: isLockerUnavailable ? 0.55 : 1,
                                }}
                            >
                                <div className="lokcer-image-container">
                                    <img alt={`${locker.code} locker`} src={getLockerSizeImage(locker.code)} />
                                </div>

                                <div className="locker-sizes-container">
                                    <div className="locker-dimentaion-container">
                                    <h3>{t('locker_size_code_locker', { code: locker.name, ...unitLabelParams })}</h3>
                                    <span>
                                        {convertToInch(
                                            locker?.width,
                                            locker?.depth,
                                            locker?.height
                                            )}
                                    </span>
                                    </div>
                                    <h4>{t('lockers_available_text', { count: locker?.available_doors_count, ...unitLabelParams })}</h4>
                                    <h2></h2>
                                </div>
                                { isPricingEnabled ?
                                <div className="locker-price-button-container">
                                    <h1 className="locker-price">
                                        {
                                        IsAdvanceBooking &&
                                        (price24h !== null ? `${getSymbolFromCurrency(lockerCurrency)} ${(price24h)} Per Day ` : '')
                                        }
                                
                                    </h1>
                                    <div className="lokcer-button-container">    
                                    <button onClick={() => decreaseQty(locker)} disabled={isLockerUnavailable || selectedLockerCount === 0}>-</button>
                                    <span>
                                        {selectedLockerCount}
                                    </span>
                                    <button
                                        onClick={() => increaseQty(locker,price24h)}
                                        disabled={
                                        isLockerUnavailable ||
                                        selectedLockerCount >= availableDoorsCount
                                        }
                                    >
                                        +
                                    </button>
                                    </div>
                                </div>
                                :
                                <div>
                                    <ButtonComponent
                                        type="primary"
                                        handleClick={()=> lockerSizeClickHandler(locker)}
                                        title={t('book_lockers_button', unitLabelParams)}
                                        disabled={isLockerUnavailable}
                                    />
                                </div>
                                }
                            </div>
                        );
                    })}

                    { isPricingEnabled &&
                        <div className="bottom-container-button">
                            {IsAdvanceBooking &&(
                                <div className="summary-amount-container">
                                    <h1>{t('total_label')}</h1>
                                    <h1>{`${getSymbolFromCurrency(lockerCurrency)} ${totalPrice}`}</h1>
                                </div>
                            )}
                            <ButtonComponent
                                title={t('book_lockers_button', unitLabelParams)}
                                handleClick={handleSelectedLokcerObject}
                                disabled={selectedLockers.length === 0}
                            />
                        </div>
                    }
                    </>
                ) : (
                    <p>{t('no_locker_here_text', unitLabelParams)}</p>
                )}
            </div>
            <div>
        </div>
            </div>
            {showBulkSlotModal && selectedLockers?.length > 0 && (
                <LockerModalContent
                    lockerCurrency={lockerCurrency != 'null' ? lockerCurrency : selectedLockers[0]?.currency}
                    lockerInfos={selectedLockers[0]}
                    selectedDuration={bulkSelectedDuration}
                    onConfirm={handleBulkConfirmSlot}
                    onCancel={() => setShowBulkSlotModal(false)}
                />
            )}
            <CustomDialog
                dialogId="booking-instructions-dialog"
                dialogVisible={showBookingInstructionModal}
                onClose={handleBookingInstructionsCancel}
                handleCancel={handleBookingInstructionsCancel}
                handleAccept={handleBookingInstructionsContinue}
                dialogTitle={t('payment_instructions_heading')}
                buttonOneTitle= {t('button_cancel')}
                buttonTwoTitle= {t('button_continue')}
                buttonProps={{
                    buttonOne: { type: BUTTON_WARNING },
                    buttonTwo: { type: BUTTON_PRIMARY }
                }}
            >
                {renderBookingInstructionsModalContent}
            </CustomDialog>
            
       
        </Box>
    )
}

export default LockerSizePage;
